import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { ArrowLeft, Loader2, MailCheck } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-6">
      <div className="w-full max-w-md">
        <img src="/ptmed-logo-dark.jpg" alt="PT-MED" className="h-14 w-14 rounded-xl object-cover mx-auto mb-6" />
        {sent ? (
          <div className="text-center space-y-4" data-testid="forgot-success">
            <div className="mx-auto h-14 w-14 rounded-full bg-primary/10 flex items-center justify-center">
              <MailCheck className="h-7 w-7 text-primary" />
            </div>
            <h2 className="font-heading text-2xl font-bold">Controlla la tua email</h2>
            <p className="text-sm text-muted-foreground">
              Se l'email è registrata, riceverai un link per reimpostare la password.
            </p>
            <Link to="/login" className="inline-flex items-center text-sm text-primary hover:underline">
              <ArrowLeft className="mr-1 h-4 w-4" /> Torna al login
            </Link>
          </div>
        ) : (
          <>
            <h2 className="font-heading text-2xl font-bold text-center">Recupera password</h2>
            <p className="text-sm text-muted-foreground text-center mt-1 mb-8">
              Inserisci la tua email e ti invieremo un link di reset.
            </p>
            <form onSubmit={submit} className="space-y-4">
              <div>
                <Label htmlFor="email">Email</Label>
                <Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required
                       data-testid="forgot-email-input" className="mt-1.5 h-11" />
              </div>
              <Button type="submit" disabled={loading} data-testid="forgot-submit-button" className="w-full h-11 font-semibold">
                {loading && <Loader2 className="mr-2 h-4 w-4 animate-spin" />} Invia link di reset
              </Button>
            </form>
            <Link to="/login" className="mt-6 inline-flex items-center text-sm text-primary hover:underline">
              <ArrowLeft className="mr-1 h-4 w-4" /> Torna al login
            </Link>
          </>
        )}
      </div>
    </div>
  );
}
